const opsStaffInitialValues = {
  id: 0,
  userBusinessId: '',
  firstName: '',
  lastName: '',
  primaryEmail: '',
  roleId: 0,
  status: true,
  notes: '',
};

export default opsStaffInitialValues;